var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32143 0.75H18.8214C20.6558 0.75 22.1429 2.22746 22.1429 4.05V13.95C22.1429 15.7725 20.6558 17.25 18.8214 17.25H3.32143C1.48705 17.25 0 15.7725 0 13.95V4.05C0 2.22746 1.48705 0.75 3.32143 0.75ZM18.8244 15.0492C19.4359 15.0492 19.9316 14.5567 19.9316 13.9492V4.0492C19.9316 3.44169 19.4359 2.9492 18.8244 2.9492H3.32443C2.71297 2.9492 2.21729 3.44169 2.21729 4.0492V13.9492C2.21729 14.5567 2.71297 15.0492 3.32443 15.0492H18.8244Z",
    fill: "#21C463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4987 7.35343C14.91 7.35753 14.3331 7.51697 13.8269 7.81543C12.4321 6.99315 10.6436 7.29194 9.59612 8.5222C8.54869 9.75246 8.54869 11.5544 9.59612 12.7847C10.6436 14.0149 12.4321 14.3137 13.8269 13.4914C15.0343 14.2032 16.5618 14.0838 17.6423 13.1932C18.7229 12.3026 19.1231 10.8331 18.642 9.52266C18.161 8.2122 16.9026 7.34378 15.4987 7.35343Z",
    fill: "#21C463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3676 11.7509C12.305 11.7562 12.242 11.7562 12.1794 11.7509C11.568 11.7509 11.0723 11.2584 11.0723 10.6509C11.0723 10.0433 11.568 9.55086 12.1794 9.55086C12.242 9.54555 12.305 9.54555 12.3676 9.55086C12.1171 10.2329 12.1171 10.9809 12.3676 11.6629V11.7509Z",
    fill: "#EFFDF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4978 11.7498C14.8863 11.7498 14.3906 11.2573 14.3906 10.6498C14.3906 10.0423 14.8863 9.5498 15.4978 9.5498C16.1092 9.5498 16.6049 10.0423 16.6049 10.6498C16.6049 11.2573 16.1092 11.7498 15.4978 11.7498Z",
    fill: "#EFFDF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.9fd97b7605a97e5161af871a3c661010.svg";
export { ForwardRef as ReactComponent };